import module from "module";
import { Routes } from "config/navigation";
import { PageWrapper, NavigationBar, ContentWrapper } from "shared/components";
import { Permission } from "shared/types";
import { DateRangeContextProvider, DateRangePicker, MetricsSection } from "../components";

const DashboardPage = () => {
  return (
    <PageWrapper>
      <NavigationBar variant="private" />
      <DateRangeContextProvider>
        <DateRangePicker />
        <ContentWrapper autoWidth>
          <MetricsSection />
        </ContentWrapper>
      </DateRangeContextProvider>
    </PageWrapper>
  );
};

export const getPageConfig = (): module.ModuleConfig => ({
  path: Routes.DASHBOARD_NEW,
  requiredPermission: Permission.USER,
  featureFlag: "new_dashboard_visible"
});

export default DashboardPage;
